import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

const allOrganizationsStatisticsService = async (token) => {
  const url = apiURl + "tables/GetAllTableStatistics";

  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const allOrganizationsStatisticsByDatesRequest = async (
  token,
  startDate,
  endDate
) => {
  const url =
    apiURl +
    `tables/GetTableStatisticsByDate?&startDate=${startDate}&endDate=${endDate}`;

  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

export {
  allOrganizationsStatisticsService,
  allOrganizationsStatisticsByDatesRequest,
};
